import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  display,
  dimension,
  position,
  padding,
  margin,
  flexChild,
  flexParent,
  font,
  background,
  animation,
  border,
} from '../styleHelper2';

const AnchorLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  color: ${props => props.theme.primary.normal};
  ${display()}
  ${dimension()}
  ${position()}
  ${padding()}
  ${margin()}
  ${background()}
  ${flexParent()}
  ${flexChild()}
  ${font()}
  ${animation()}
  ${border()}
`;

export default AnchorLink;
